export const options = {
    initial: {
        opacity: 0,
    },
    animate:{
        y: "0px",
        opacity: 1
    },
    exit: {
        x: 0,
        opacity: 0
    }

}
